import React, { useRef, useState } from 'react';
import { navigate } from 'gatsby-link';
import TypeScale from '@identity/type';
import { colors } from '@identity/constants';
import { FormContainer, Form, Button, ButtonContainer } from './styles';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import Select from 'react-select';

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

const ContactForm = props => {
  const form = useRef();
  const emailValidator = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$';

  const [state, setState] = React.useState({});

  const handleInputs = e => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleDropdown = ({ value }) => {
    setState({ ...state, package: value });
  };

  const options = [
    { value: 'wedding', label: 'Wedding' },
    { value: 'reception', label: 'Reception' },
    { value: 'ceremony', label: 'Ceremony' },
  ];

  const newDate = new Date();
  const formattedDate = newDate
    .toISOString()
    .slice(0, 10)
    .replace(/-/g, '-');

  return (
    <FormContainer>
      <div>
        <TypeScale.H1 alignText="center" noMeasure color={colors.PRIMARY_004}>
          Interested in our services?
        </TypeScale.H1>
      </div>

      <Form
        ref={form}
        name="Contact Form"
        method="post"
        action="/thanks"
        data-netlify="true"
        onInvalid={e => e.preventDefault()}
      >
        <input type="hidden" name="form-name" value="Contact Form" />

        <TypeScale.H3 alignText="center" spacing={{ padding: 'top-md' }}>
          Personal Info
        </TypeScale.H3>
        <label>Full Name *</label>
        <input required name="full-name" type="text" onChange={handleInputs} />

        <label>Email *</label>
        <input
          pattern={emailValidator}
          required
          name="email"
          type="email"
          onChange={handleInputs}
        />

        <label>Phone *</label>
        <input required name="phone" type="tel" onChange={handleInputs} />

        <TypeScale.H3 alignText="center" spacing={{ padding: 'top-lg' }}>
          Event Info
        </TypeScale.H3>

        <label>Event Date</label>
        <input
          name="date"
          type="date"
          data-date-inline-picker="true"
          min={formattedDate}
          onChange={handleInputs}
        />

        <label>Event Location</label>
        <input name="location" type="text" onChange={handleInputs} />

        <label>Esitmated Guests</label>
        <input name="guests" type="number" onChange={handleInputs} />

        <label>Esitmated Budget</label>
        <input name="budget" type="number" onChange={handleInputs} />

        <label>What services are you interested in?</label>
        <Select name="package" onChange={handleDropdown} options={options} />

        <label>Tell us more about your event.</label>
        <textarea name="tell-us-more" onChange={handleInputs} />

        <ButtonContainer
          formInvalid={form.current && !form.current.checkValidity()}
        >
          <Button type="submit" value="Submit">
            <TypeScale.H1 color={colors.BLACK_006}>Submit</TypeScale.H1>
          </Button>
        </ButtonContainer>
      </Form>
    </FormContainer>
  );
};

export default ContactForm;
